import React from 'react'
import { Text } from '@chakra-ui/core'

const HugeText = props => <Text {...props} fontSize='7xl' fontWeight='700' />

export default HugeText